<template>
  <div class="page-style">
    <b-row>
      <b-col cols="3">
        <b-img :src="require('/static/images/netech.png')" fluid alt="Responsive image" width="230" />
      </b-col>

      <b-col cols="6" class="pt-4"> </b-col>

      <b-col cols="3" class="pl-5">
        <b-row><field-label :label="'ID. Relatório'" :field="laudo.numero" /></b-row>
        <b-row><field-date-label :label="'Data'" :field="laudo.data" /></b-row>
      </b-col>
    </b-row>
    <hr />

    <div class="page-body">
      <b-row class="mt-2">
        <b-col cols="12" class="p-0">
          <div class="separador-div">
            <strong>RECOMENDAÇÕES</strong>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-3 ml-3">
        <b-col cols="12" class="p-0 text-left">
          <h5 :style="{ textIndent: 40 + 'px' }">{{ laudo.recomendar }}</h5>
        </b-col>
      </b-row>

      <b-row class="mt-3 ml-3">
        <b-col cols="12" class="p-0 text-left">
          <b-table bordered hover small :items="laudo.recomendacoes" :fields="fields.item_recomendacoes"> </b-table>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="12" class="p-0">
          <div class="separador-div">
            <strong>CONCLUSÃO</strong>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-3 ml-3">
        <b-col cols="12" class="p-0 text-left">
          <h5 :style="{ textIndent: 40 + 'px' }">{{ laudo.conclusao }}</h5>
        </b-col>
      </b-row>

      <b-row class="text-left mt-5">
        <b-col cols="4" class="mt-5"> </b-col>
        <b-col cols="4" class="mt-5"> </b-col>
        <b-col cols="4" class="mt-5">
          <div class="separador-div">
            <strong>ENGENHEIRO RESPONSÁVEL</strong>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4" class="m-0 p-0"> </b-col>
        <b-col cols="4" class="m-0 p-0"> </b-col>
        <b-col cols="4">
          <inspetor-stamp :profissional="laudo.responsavel" :preview="stampInspetor" :posicao="'6rem'" key="insp-stamp-pm" />
        </b-col>
      </b-row>
    </div>

    <hr />
    <b-row>
      <h5 class="ml-4">{{ laudo.rodape }}</h5>
    </b-row>
  </div>
</template>

<script>
import FieldAndLabel from "@/components/reports/parts/FieldAndLabel";
import FieldDateAndLabel from "@/components/reports/parts/FieldDateAndLabel";
import ReportFields from "@/tools/ReportFields";
import StampCertificado from "@/components/supports/StampCertificado";

export default {
  name: "FirstLaudoTecnicoReport",

  props: ["laudo", "equipamento"],

  components: {
    "field-label": FieldAndLabel,
    "field-date-label": FieldDateAndLabel,
    "inspetor-stamp": StampCertificado,
  },

  data() {
    return {
      fields: new ReportFields(),
      stampInspetor: null,
    };
  },

  methods: {},

  setup() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.page-style {
  width: 100%;
}

.page-body {
  height: 1300px;
}

.separador-div {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  background-color: #003c5a;
  border-radius: 4px;
  color: white;
  text-align: justify; /* For Edge */
  text-align-last: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.max-size {
  max-height: 560px;
}
</style>
